/* @flow */

import { makeListLink } from './utils';

export default makeListLink({ pathname: '/protocol', children: 'protocol' });



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/components/Links/ProtocolLink.js